var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M16 8C16 3.5808 12.4184 0 8 0C3.5816 0 0 3.5808 0 8C0 12.4176 3.5816 16 8 16C12.4184 16 16 12.4176 16 8Z",
    fill: "#737FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.69688 7.49642C8.69688 7.11082 8.38248 6.79642 7.99688 6.79642C7.61128 6.79642 7.29688 7.11082 7.29688 7.49642V11.0324C7.29688 11.418 7.61128 11.7324 7.99688 11.7324C8.38248 11.7324 8.69688 11.418 8.69688 11.0324V7.49642ZM7.30153 4.95625C7.30153 5.34185 7.61433 5.65625 7.99753 5.65625C8.39193 5.65625 8.70553 5.34185 8.70553 4.95625C8.70553 4.57065 8.39193 4.25625 8.00553 4.25625C7.61753 4.25625 7.30153 4.57065 7.30153 4.95625Z",
    fill: "#737FA4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSvg);
export default __webpack_public_path__ + "static/media/info-svg.325d97e9.svg";
export { ForwardRef as ReactComponent };